import styled, { css } from 'styled-components';
import { Grid, Card } from '@material-ui/core';



export const Wrapper = styled(Grid)`
  margin: auto;

  display:grid;
  grid-template-columns: 1fr 0.3fr 1fr;
  gap: 10px;

  .MuiGrid-container {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    box-sizing: border-box;
}

  .MuiCard-root {
    width:100%;
    overflow: auto !important;
  }

  .MuiTableCell-sizeSmall{
    max-width:200px;
  }


  @media(max-width:900px){
    grid-template-columns: 1fr;

    .MuiGrid-root.MuiGrid-item{
      display:flex;
      flex-flow:column;
      align-items:center;
    }
  }
`;

export const WrapperButtons = styled(Grid)`
  button:not(:last-child) {
    margin-bottom: 1.3rem;
  }
`;

export const WrapperPaper = styled(Card)`
  // width: 23rem;
  width:100%;
  height: ${({ grid }) => (grid ? '100%' : '21rem')};

  ${({ maxWidth }) =>
    maxWidth &&
    css`
      width: ${maxWidth}rem;
    `}

  overflow: auto;
`;

export const GridItem = styled(Grid)`

  .MuiGrid-container {
    flex-wrap: nowrap;
}
`
